// 原稿タイプ
export const JOB_MANUSCRIPT_TYPE = {
  typeA: 'A',
  typeB: 'B',
  typeC: 'C',
  typeD: 'D',
  typeE: 'E',
  typeS: 'S',
  typeT: 'T',
};
